import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";

interface GuestViewProps {
  children?: React.ReactNode;
}

const GuestView = (props: GuestViewProps) => {
  const navigate = useNavigate();
  return (
    <StyledGuestView>
      <StyledTitles>
        <h2>Take your business to the next level</h2>
        <p>
          One extra move to open all your Data Gates choose your plan and let
          get started
        </p>
        <StyleButton
          onClick={() => navigate("/subscription", { replace: true })}
        >
          Subscribe
        </StyleButton>
      </StyledTitles>
    </StyledGuestView>
  );
};

export default GuestView;

const StyledTitles = styled.div`
  // max-width: 360px;
  // padding-left: 20px;
  text-align: left;
  h1 {
    font-size: 30px !important;
  }
  p {
    font-size: 15px !important;
  }
`;

const StyleButton = styled(Button)`
  background: #4974f6 !important;
  color: #eff1fd !important;
  border: none;
  height: 35px !important;
  width: 60%;
  border-radius: 30px;
`;

const StyledGuestView = styled.div`
  width: 80%;
  display: flex;
  align-items: flex-start;
`;
